import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import AnalyticsTracker from "./components/AnalyticsTracker"
import ScrollToTop from "./components/Common/ScrollToTop"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import store  from "./store";


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.Fragment>
    <Provider store={store}>
    <BrowserRouter>
      <AnalyticsTracker />
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </Provider>
  </React.Fragment>
);

serviceWorker.unregister()